import React from "react";

import { InfiniteList } from "../../components";
import { OrderItem } from "./index.jsx";

const OrdersList = ({
  emptyText = "You haven't made any orders yet.",
  user,
  params,
}) => {
  return (
    <InfiniteList
      className="orders user-orders"
      fetchUrl={`/api/user/${user.id}/orders`}
      fetchParams={params}
      emptyText={emptyText}
      ItemComponent={OrderItem}
    />
  );
};

export default OrdersList;
